export interface ITimeLabel {
  label: string;
  value: number;
}

export const timeLabels: ITimeLabel[] = [
  {label:'15 мин', value: 15}, 
  {label: '30 мин', value: 30}, 
  {label: 'час', value: 60}, 
  {label: 'день', value: 1440},
];

export const getTimeLabelsFromMinutes = (minutes: number) => (
  timeLabels.find((elem) => elem.value === minutes)?.label ?? getStringifyTime(minutes)
)

const getStringifyTime = (minutes: number) => {
  if (minutes < 60 || minutes % 60 !== 0) {
    return `${minutes} мин.`;
  } 
  if (minutes % 60 === 0) {
    return (`${minutes / 60} ч.`)
  }
}